import { HeatMapSpec, heatMapSpecSchema } from '../../../core';
import { createVisualization, mapPropsToSpec, mapSpecToProps, PropToSpecMapping } from '../../../plugin-system';
import { HeatMapIcon } from './HeatMapIcon';
import { HeatMapPanel } from './HeatMapPanel';
import { HeatMapPanelProps } from './heat-map-model';
import { HeatMapOptionsEditorSettings } from './options-editor/HeatMapOptionsEditorSettings';

export const HEAT_MAP_PROP_TO_SPEC_MAPPING: PropToSpecMapping<HeatMapPanelProps, HeatMapSpec> = {
  yAxis: 'y_axis',
  color: 'color',
  legend: 'legend',
};

export const HeatMap = createVisualization(HeatMapPanel, {
  dashboardConfig: {
    kind: 'HeatMap',
    mapSpecToProps: (spec: HeatMapSpec) => mapSpecToProps(spec, HEAT_MAP_PROP_TO_SPEC_MAPPING),
    mapPropsToSpec: (props) => mapPropsToSpec(props, HEAT_MAP_PROP_TO_SPEC_MAPPING),
    createInitialOptions: () => {
      return {} as HeatMapSpec;
    },
    panelOptionsEditorComponents: [{ label: 'Settings', content: HeatMapOptionsEditorSettings }],
    schema: heatMapSpecSchema,
    supportedDataType: 'HeatMap',
    icon: HeatMapIcon,
  },
});

export type HeatMapVizProps = React.ComponentProps<typeof HeatMap.Viz>;
export type HeatMapVizBaseProps = React.ComponentProps<typeof HeatMap.VizBase>;
